export const FORM_ERRORS = {
  REQUIRED: "Este campo é obrigatório",
  ALPHA_CHARACTERES:
    "Este campo deve conter apenas letras, números e pontos (.)",
  ONLY_NUMBERS: "Este campo deve conter apenas números"
};

export const BUTTONS = {
  LOGIN: "Entrar"
};

export const LOADS = {
  LOGIN: "Validando seu login e sua senha"
};



// WEBPACK FOOTER //
// ./src/texts/index.js